export default __webpack_public_path__ + "static/media/egg.f445ea46.png";